import { memo } from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

type Props = {
  handleLoadMoreRealTimeNotifications: () => void;
  disabled: boolean;
};

/**
 * @component LoadMoreButton component renders a button that allows users to load more real-time notifications.
 *
 * @param {Object} props - The component props.
 * @param {function} props.handleLoadMoreRealTimeNotifications - Function to call when the button is clicked
 * to load more notifications.
 * @param {boolean} props.disabled - Indicates whether the button should be disabled.
 *
 * @returns {JSX.Element} The rendered LoadMoreButton component.
 */
function LoadMoreButton({
  handleLoadMoreRealTimeNotifications,
  disabled
}: Props): JSX.Element {
  const handleClick = () => {
    handleLoadMoreRealTimeNotifications();
  };

  const { t } = useTranslation('global');

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 12
      }}
    >
      <Button disabled={disabled} onClick={handleClick}>
        <Typography variant="body1">{t('notifications.showMore')}</Typography>
      </Button>
    </div>
  );
}

export default memo(LoadMoreButton);
